export default "__VITE_ASSET__C7dby3St__"